import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import styles from "../../../styles/LandingPagev1/form-modal.module.css";

ReactModal.setAppElement("#root");

const drawerOverlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(5px)',
    zIndex: 1000,
};

const drawerStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '90vh',
    background: '#ffffff',
    borderRadius: '24px 24px 0 0',
    boxShadow: '0 -4px 10px rgba(0,0,0,0.1)',
    overflowY: 'auto',
    zIndex: 1001,
    display: 'flex',
    flexDirection: 'column',
    overscrollBehavior: 'contain',
};

const drawerContentStyle = {
    padding: '20px 16px 32px',
    flex: 1,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
};

const MobileFormDrawer = ({ children, onRequestClose }) => {
    return (
        <React.Fragment>
            <div style={drawerOverlayStyle} onClick={onRequestClose} />
            <div style={drawerStyle} role="dialog" aria-modal="true">
                <div style={drawerContentStyle}>
                    {children}
                </div>
            </div>
        </React.Fragment>
    );
};
const FormModal = ({ isOpen, onRequestClose, children }) => {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    /*  Lock background scroll via event prevention — NOT body style changes.
        Why not CSS approaches:
        • overflow:hidden on body → resets scrollY on iOS Safari
        • position:fixed on body → breaks position:sticky descendants (ClosedLoopSection)
        Event prevention keeps the DOM completely untouched:
        scroll position is preserved, sticky behaviour keeps working,
        and the page stays exactly where it is when the modal opens. */
    useEffect(() => {
        if (!isOpen) return;

        const blockScroll = (e) => {
            // Allow scroll inside the modal dialog (drawer content / ReactModal)
            const dialog = document.querySelector('[role="dialog"]');
            if (dialog && dialog.contains(e.target)) return;
            e.preventDefault();
        };

        window.addEventListener('touchmove', blockScroll, { passive: false });
        window.addEventListener('wheel', blockScroll, { passive: false });

        return () => {
            window.removeEventListener('touchmove', blockScroll);
            window.removeEventListener('wheel', blockScroll);
        };
    }, [isOpen]);

    if (!isOpen) return null;

    if (isMobile) {
        return <MobileFormDrawer onRequestClose={onRequestClose}>{children}</MobileFormDrawer>;
    }
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            overlayClassName={styles.modalOverlay}
            className={styles.modal}
            closeTimeoutMS={300}
            shouldCloseOnOverlayClick={false}
        >
            {children}
        </ReactModal>
    );
};

export default FormModal;
